export default function transformOptions(options) {
	return options.map((option, i) => {
		return { ...option, index: i };
	});
}
